import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';
import {BaseWebservice} from '../../../shared/base/base.webservice';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, service:BaseWebservice,private route:Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    // if(!currentUser.plan || currentUser.plan == null ) {
    //   this.route.navigate(['/plan'])
    // }
    if (currentUser) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    // this.authService.logout();

      // this.route.navigate(["/registration"])
      this.route.navigate(['/auth/registration']);
    return false;
  }
}
